// ─── PSEO Rich Content ────────────────────────────────────────────────────────
// Differentiated copy per industry, use-case, and competitor.
// Applied in PseoPageLayout to replace generic hardcoded cards.

export interface PseoFeatureCard {
  title: string;
  body: string;
}

export interface PseoStat {
  value: string;
  label: string;
}

export interface PseoPainPoint {
  problem: string;
  solution: string;
}

export interface FaqItem {
  question: string;
  answer: string;
}

export interface PseoContent {
  headline: string;
  subheadline: string;
  features: PseoFeatureCard[];
  painPoints: PseoPainPoint[];
  stats: PseoStat[];
  faqs: FaqItem[];
  ctaHeadline: string;
  ctaBody: string;
}

export { industryContent } from './industry-content';
export { useCaseContent } from './usecase-content';
export type { ComparisonRow, CompetitorContent } from './competitor-content';
export { competitorContent } from './competitor-content';
